import React from 'react';

interface UploadProgressProps {
  progress: number; // 0-100
  status?: string;  // messaggio opzionale come "Caricamento in corso..."
}

/**
 * Barra di progresso per l'upload di un video.
 * Mostra una barra animata con percentuale e messaggio di stato.
 */
const UploadProgress: React.FC<UploadProgressProps> = ({ progress, status }) => {
  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div style={{ width: '100%', maxWidth: '600px', margin: '1rem auto' }}>
      {status && (
        <p style={{ margin: '0 0 0.5rem 0', fontSize: '0.9rem', color: '#475569', fontWeight: 500 }}>
          {status}
        </p>
      )}
      <div
        style={{
          width: '100%',
          height: '24px',
          backgroundColor: '#e2e8f0',
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.1)',
        }}
      >
        <div
          style={{
            width: `${clampedProgress}%`,
            height: '100%',
            backgroundColor: '#3b82f6',
            borderRadius: '12px',
            transition: 'width 0.3s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: clampedProgress > 5 ? '40px' : '0',
          }}
        >
          {clampedProgress > 10 && (
            <span style={{ color: 'white', fontSize: '0.75rem', fontWeight: 600 }}>
              {clampedProgress}%
            </span>
          )}
        </div>
      </div>
      {clampedProgress <= 10 && (
        <p style={{ textAlign: 'center', margin: '0.25rem 0 0', fontSize: '0.8rem', color: '#64748b' }}>
          {clampedProgress}%
        </p>
      )}
    </div>
  );
};

export default UploadProgress;